import { useEffect, useState } from 'react'
import { api } from '../api/client'
import MonthNavigator from '../components/MonthNavigator'
import BloodPressureChart from '../components/charts/BloodPressureChart'
import SugarInsulinChart from '../components/charts/SugarInsulinChart'
import UltrafiltrationChart from '../components/charts/UltrafiltrationChart'
import WeightChart from '../components/charts/WeightChart'

function currentMonth() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

function EmptyHint() {
  return (
    <div className="rounded-2xl border-4 border-dashed border-white bg-navy-800 p-8 text-center">
      <p className="text-3xl font-bold text-white">這段期間資料還不足，繼續記錄喔！</p>
      <p className="mt-2 text-xl text-gray-300">記越多天，圖表越清楚，起床血糖和睡前血糖也會一起畫出來</p>
    </div>
  )
}

export default function ChartsPage() {
  const [month, setMonth] = useState(currentMonth())
  const [range, setRange] = useState('default')
  const [data, setData] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let alive = true
    const query = range === '30days' ? 'days=30' : `month=${month}`
    setData(null)
    setError('')
    api(`/charts/summary?${query}`)
      .then((d) => alive && setData(d))
      .catch((e) => alive && setError(e.message))
    return () => {
      alive = false
    }
  }, [month, range])

  return (
    <div>
      <h1 className="mb-3 text-3xl font-bold text-white">📈 血糖與洗水趨勢圖表</h1>
      <label className="mb-3 block text-xl font-bold text-white">
        顯示範圍
        <select
          value={range}
          onChange={(event) => setRange(event.target.value)}
          className="ml-3 rounded-xl bg-white px-3 py-2 text-navy-900"
        >
          <option value="default">預設（依月份）</option>
          <option value="30days">連續三十天</option>
        </select>
      </label>
      {range === 'default' ? (
        <MonthNavigator value={month} onChange={setMonth} />
      ) : (
        <p className="mb-4 text-center text-xl font-bold text-white">顯示最近連續三十天</p>
      )}
      {error && <p className="mb-2 text-center text-xl font-bold text-red-300">⚠️ {error}</p>}

      {!data && !error && <p className="text-center text-2xl text-gray-300">載入中…</p>}

      {data && (
        <div className="space-y-4">
          {data.vitals.length ? <BloodPressureChart data={data.vitals} /> : <EmptyHint />}
          {data.weight.length ? <WeightChart data={data.weight} /> : <EmptyHint />}
          {data.sugar_insulin.length ? (
            <SugarInsulinChart data={data.sugar_insulin} />
          ) : null}
          {data.ultrafiltration.length ? (
            <UltrafiltrationChart data={data.ultrafiltration} />
          ) : null}
        </div>
      )}
    </div>
  )
}
